import AssetUtils from "./AssetUtils";

/**
 * @typedef {import("@/types/data/Asset.mjs").Asset} Asset
 * @typedef {Pick<Asset, "key" | "asset_name" | "ext">} KeyedAsset
 */

/**
 * The name the user gave the file, with its extension. Failed uploads have an empty `ext`.
 * @param {Pick<Asset, "asset_name" | "ext">} asset
 * @returns {string}
 */
const getAssetFileName = (asset) =>
  asset.ext === "" ? asset.asset_name : `${asset.asset_name}.${asset.ext}`;

/**
 * @param {KeyedAsset[] | undefined} assets
 * @param {string} key
 * @returns {KeyedAsset | undefined}
 */
const findAssetByKey = (assets, key) => assets?.find((asset) => asset.key === key);

/**
 * File name for an element's asset key. Falls back to the key's filename for
 * keys outside the user's uploads (stock photos, shared/library assets, deleted files).
 * @param {KeyedAsset[] | undefined} assets - The user's uploaded assets, from `useUserAssets`.
 * @param {string} key
 * @returns {string}
 */
export const getAssetFileNameFromKey = (assets, key) => {
  const asset = findAssetByKey(assets, key);
  return asset === undefined ? AssetUtils.getNameFromKey(key) : getAssetFileName(asset);
};
